﻿import { analyticsEvent } from "../Utils/matomoAnalytics";

export default class FaqAccordionHandler {
    constructor() {
        this.faqItemCl = '.faq__question';
        this.faqItemActiveCl = 'open';

        this.setupEventListeners();
        this.toggleAria();
    }

    setupEventListeners = () => {
        let faqItemEls = document.querySelectorAll(this.faqItemCl);

        faqItemEls.forEach(faqItemOpen =>
            faqItemOpen.addEventListener('click', () => {
                const parent = faqItemOpen.parentNode;
                const isOpen = parent.classList.toggle(this.faqItemActiveCl);

                if (isOpen) {
                    this.triggerAnalyticsEvent(faqItemOpen);
                }
            })
        );
    };

    toggleAria = () => {
        const items = document.querySelectorAll('.faq__question');

        Array.prototype.forEach.call(items, button => {
            button.onclick = () => {
                let expanded = button.getAttribute('aria-expanded') === 'true' || false;
                button.setAttribute("aria-expanded", !expanded);
            }
        });
    }

    triggerAnalyticsEvent = (faqItem) => {
        const questionTextElement = faqItem.querySelector('.faq__question span');

       if (questionTextElement) {
           const questionText = questionTextElement.innerText;

           analyticsEvent({
               event: 'plain_faq_question_opened',
               question: questionText,
           })
        }
    }
}